import { CrudFilters, HttpError } from '@refinedev/core';
import { IReport } from 'interfaces/reports';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { ReportsFilter } from './components/list-filter';
import { ReportsTable } from './components/list-table';
import { useTable } from '@refinedev/antd';

export interface IFilter {
  by_reason: string;
  by_status: string;
}

export const ReportsList = () => {
  const { tableProps, searchFormProps } = useTable<IReport, HttpError, IFilter>(
    {
      onSearch: params => {
        const filters: CrudFilters = [];
        const { by_reason, by_status } = params;

        filters.push(
          {
            field: 'filter[by_reason]',
            operator: 'eq',
            value: by_reason
          },
          {
            field: 'filter[by_status]',
            operator: 'eq',
            value: by_status
          }
        );

        return filters;
      },

      filters: {
        initial: [
          {
            field: 'filter[by_status]',
            operator: 'eq',
            value: 'pending'
          }
        ]
      }
    }
  );

  return (
    <ListLayout
      title="Denúncias de comentários"
      createButtonProps={{ hidden: true }}
    >
      <ReportsFilter searchFormProps={searchFormProps} />
      <ReportsTable tableProps={tableProps} />
    </ListLayout>
  );
};
